// src/components/dashboard/DashboardSkeleton.tsx
import { Skeleton } from '@/components/ui/skeleton';

export default function DashboardSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {/* KPI Skeletons */}
      <Skeleton className="h-28" />
      <Skeleton className="h-28" />
      <Skeleton className="h-28" />

      {/* Chart Skeletons */}
      <Skeleton className="h-72 md:col-span-1 lg:col-span-1" /> {/* Pie Chart */}
      <Skeleton className="h-72 md:col-span-1 lg:col-span-2" /> {/* Bar Chart */}

      {/* List Skeleton */}
      <Skeleton className="h-72 md:col-span-2 lg:col-span-3" /> {/* Recent Activity */}
    </div>
  );
}